import * as dayjs from 'dayjs'
import { gardenPlantTypes } from './Constants/PlantsConstants';
import { MeasurementType } from './Constants/MeasurementTypes.js';

export const formatBytes = (bytes) => {
    if (!bytes) return '0 B';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
}

export const estimateBase64Size = (dataUrl) => {
    if (!dataUrl) return 0;
    const base64 = dataUrl.includes(',') ? dataUrl.split(',')[1] : dataUrl;
    if (!base64) return 0;
    const padding = base64.endsWith('==') ? 2 : base64.endsWith('=') ? 1 : 0;
    return Math.floor((base64.length * 3) / 4) - padding;
}

export const getFileSize = (file) => {
    if (file == null) return 0;
    if (typeof file.size === 'number') return file.size;
    return estimateBase64Size(file.thumbnailImage);
}

export const preparePhotos = (data) => {
    let allfiles = []
    if (data && data.length) {

        for (let i = 0; i < data.length; i++) {
            let image = data[i];
            image.thumbnailImage = 'data:image/jpeg;base64,' + image.thumbnailImage

            allfiles.push(image);
        }
        return allfiles;
    }
    return allfiles;
}

export const groupByKey = (array, key) => {
    return array.reduce(function (obj, x) {
        (obj[x[key]] = obj[x[key]] || []).push(x);
        return obj;
    }, {});
}
export const groupByMarked = (array, markedKey, nonMarkedKey) => {
    var marked = {}
    var nonMarked = {}

    for (var i = 0; i < array.length; i++) {
        var m = array[i][markedKey];
        var n = array[i][nonMarkedKey];
        if (m) {
            if (!marked[m]) { marked[m] = []; }
            marked[m].push(array[i]);
        }
        if (!m && n) {
            if (!nonMarked[n]) { nonMarked[n] = []; }
            nonMarked[n].push(array[i]);
        }

    }
    return [{ ...marked }, { ...nonMarked }];
}

export let groupTillings = function (tillings) {
    let combineArr = [];

    tillings.forEach(element => {
        let object = Object.assign({}, element);

        object.tillNo = element.number ? element.way + '_' : element.way;
        object.subList = [];
        object.subList.push(element);
        combineArr.push(object);
    });

    var productGroup = groupByKey(combineArr, 'tillNo');

    var groupedByDate = [];
    for (var i in productGroup) {

        var productGroup2 = groupByKey(productGroup[i], 'plannedDate');

        for (var j in productGroup2) {
            groupedByDate.push(productGroup2[j]);
        }
    };

    return groupedByDate;
}

export let groupFertilizers = function (ferts) {
    let combineArr = [];
    ferts.forEach(function (element) {
        let object = Object.assign({}, element);

        object.fertNo = element.pesticideId ? element.product + '_' : element.product;
        object.subList = [];

        //if (element.pesticideId) {
        //    let s = combineArr.find(c => c.pesticideId === element.pesticideId);
        //    if (s) {
        //        s.subList.push(element);
        //    }
        //    else {
        //        object.subList.push(element);
        //        combineArr.push(object);
        //    }
        //}
        //else
        {
            object.subList.push(element);
            combineArr.push(object);
        }
    });

    var productGroup = groupByKey(combineArr, 'fertNo');

    var groupedByDate = [];
    for (var i in productGroup) {

        var productGroup2 = groupByKey(productGroup[i], 'plannedDate');

        for (var j in productGroup2) {
            groupedByDate.push(productGroup2[j]);
        }
    };

    return groupedByDate;
};

export let groupPesticides = function (pests) {
    let flattenObjects = [];
    pests.forEach(function (element) {
        if (element.pesticides.length > 0 || element.fertilizings.length > 0) {
            const object = {
                plannedDate: null,
                growthInformation: {},
                productsGroupNo: [],
                fertilizers: [],
                pesticides: [],
            };

            var obj = Object.assign({}, element);

            if (obj.growthInformation && (obj.growthInformation.plannedDate || obj.growthInformation.date)) {
                object.growthInformation = obj.growthInformation;
                object.plannedDate = obj.growthInformation.plannedDate;

                obj.pesticides.forEach(p => {
                    if (p.pesticideRowKey) {
                        object.productsGroupNo.push(p.product);
                        object.pesticides.push(p);
                    }
                });

                obj.fertilizings.forEach(f => {
                    object.productsGroupNo.push('f' + f.product);
                    object.fertilizers.push(f);
                });
            }

            if (object.productsGroupNo.length) flattenObjects.push(object);
        }
    });

    var productGroup = groupByKey(flattenObjects, 'productsGroupNo');

    var groupedByDate = [];
    for (var i in productGroup) {

        var productGroup2 = groupByKey(productGroup[i], 'plannedDate');

        for (var j in productGroup2) {
            groupedByDate.push(productGroup2[j]);
        }
    };
    return groupedByDate;
};

export const toggleActive = (activeId, cardId, setActiveId) => {
    if (activeId === cardId) {
        setActiveId(0);
    } else {
        setActiveId(cardId);
    }
}

export const formatPlannedDate = (date, t) => {
    if (!date) return "";
    var year = date.slice(0, 4);
    var month = Number(date.slice(4, 6));
    var seasonCode = "";
    if ([1, 2].includes(month)) {
        seasonCode = 'Season_Winter';
    } else if ([3, 4, 5].includes(month)) {
        seasonCode = 'Season_Spring';
    } else if ([6, 7].includes(month)) {
        seasonCode = 'Season_Summer';
    } else if (month === 8) {
        seasonCode = 'Season_AutumnSummer';
    } else if ([9, 10, 11].includes(month)) {
        seasonCode = 'Season_Autumn';
    } else if (month === 12) {
        seasonCode = 'Season_Winter';
    }
    return t(seasonCode) + ' ' + year;
}

export const getGrowthStageText = (growthStage, t) => {
    if (growthStage >= 10 && growthStage <= 19)
        return t('GrowthStage_Seedling');
    if (growthStage >= 20 && growthStage <= 29)
        return t('GrowthStage_Tillering');
    if (growthStage >= 30 && growthStage <= 39)
        return t('GrowthStage_StemElongation');
    if (growthStage >= 40 && growthStage <= 49)
        return t('GrowthStage_Booting');
    if (growthStage >= 50 && growthStage <= 59)
        return t('GrowthStage_EarEmergence');
    if (growthStage >= 60 && growthStage <= 69)
        return t('GrowthStage_Flowering');
    if (growthStage >= 70 && growthStage <= 79)
        return t('GrowthStage_SeedDevelopment');
    if (growthStage >= 80 && growthStage <= 99)
        return t('GrowthStage_Ripening');

    return t('GrowthStage_Zero');
}

export const selectFertilizerName = (fert) => {
    if (!fert) return '';

    if (fert.productName)
        return fert.productName;
    else if (fert.description)
        return fert.description
    else
        return ''
}

export let checkSelectedPlants = (selectedPlotsData) => {
    let plants = [];
    selectedPlotsData.map(function (a) {
        if (plants.indexOf(a.plantId) === -1) plants.push(a.plantId);
    });
    return plants;
}

export let checkSowButtonState = (selectedPlotsData) => {
    const checkProductionType = (plots) => {
        let productionTypes = [];
        plots.forEach(function (a) {
            if (productionTypes.indexOf(a.productionType) === -1) productionTypes.push(a.productionType);
        });
        // Return false if there are more than 1 production types == Incompatible plots
        if (productionTypes.length > 1) return false;
        return true;
    }
    let plants = checkSelectedPlants(selectedPlotsData);
    let productionTypeCheck = checkProductionType(selectedPlotsData);
    if (plants.length === 1 && plants.some(p => p !== 0) && productionTypeCheck)
        return false; // return false to enable sow button
    
    return true; // return true to disable sow button
};

export let checkPlotsHaveNoPlant = (selectedPlotsData) => {
    let plants = checkSelectedPlants(selectedPlotsData);
    if (plants.length === 1 && plants.some(p => p !== 0))
        return false; // disabled false
    else
        return true;
};

export let dayJsFormatDate = (date) => {
    return dayjs(date).format("DD.MM.YYYY");
}

// sow, fertilize modal amount max value
export let valueMax = (inputObj) => {
    let { value } = inputObj;
    if (Number(value) < 1000000) return true;
    return false;
};

export let isValidInputValue = (inputObj) => {
    let value  = Number(inputObj);
    if (value < 1000000 && value > 0) return true;
    return false;
}

// observation density
export let valueMaxObservation = (inputObj) => {
    const { value } = inputObj;
    if (value < 100000) return true;
    return false;
};

export let valueMaxArea = (inputObj) => {
    const { value } = inputObj;
    if (value < 1000) return true;
    return false;
};

export let valueMaxDryMaterialPercentage = (inputObj) => {
    const { value } = inputObj;
    if (value <= 100) return true;
    return false;
};


export let round = (value) => {
    return Math.round(value * 100) / 100;
}

/**
 * Function for updating calculation array for combined data for harvest load.
 */
export const UpdateHarvestLoad = (calculationCombinedData, floatValue, i, j, isWagon) => {
    let newArr = [...calculationCombinedData];
    var harvest = newArr[i].objects[j];

    var baleAmountCalc = ((floatValue * harvest.combinedData.baleWeight) / harvest.combinedArea) * (harvest.combinedData.dryMateriaContent / 100);
    var wagonAmountCalc = ((floatValue * harvest.combinedData.trailerVolume * harvest.combinedData.volumeWeight) / harvest.combinedArea) * (harvest.combinedData.dryMateriaContent / 100);

    newArr[i].objects[j].combinedData.amount = isWagon ? wagonAmountCalc : baleAmountCalc;

    return newArr;
};

// Calculations of sum of areas and amounts to marking modals
export const updateCalculativeArray = (calculationCombinedData, floatValue, i, j, k, pest) => {
    let newArr = [...calculationCombinedData];
    // For mark pescticides modal
    if (k && pest) {
        // Pesticides
        if (pest === true)
            newArr[i].objects[j].combinedAmounts.find(p => p.product === newArr[i].objects[j].combinedData.pesticides[k].product).amount = floatValue;
        // Fertilizers
        else if (pest === false)
            newArr[i].objects[j].combinedAmounts.find(p => p.product === newArr[i].objects[j].combinedData.fertilizer[k].product).amount = floatValue;
    }
    // For mark sows & fertilizers
    else { 
        newArr[i].objects[j].combinedData.amount = floatValue;
    }

    return newArr;
}

export const GardenPlantCheck = (plantId) => {
    return gardenPlantTypes.includes(plantId.substring(0, 2));
};

export const IsIrrigation = (value) => {
    const spreadingMethod_irrigation = 6;
    if (value === spreadingMethod_irrigation) {
        return true;
    }

    return false;
}

/**
 * Function to check if given plot is organic plot 
 */
export function IsOrganicPlot(plot) {
    const hasOrganic = (plot.plotProductionType === 1 || plot.plotProductionType === 2 ||
        plot.plotProductionType === 3 || plot.plotProductionType === 4 || plot.plotProductionType === 5);
    return hasOrganic;
}

export function getOrganicSeedText(value, options) {
    if (!options || !options.length || value === null) return "";
    var organicOption = options.find(o => o.value === value);
    if (!organicOption) {
        // If production type is not in paramints, set default value to normal or organic based on plot production type
        let defaultNormal = options.find(o => o.value === 0);
        let defaultOrganic = options.find(o => o.value === 1);
        var isOrganic = IsOrganicPlot({ plotProductionType: value });
        organicOption = isOrganic ? defaultOrganic : defaultNormal;
    }
    return organicOption.label;
}

export const getProPlusUrl = (lang) => {
    return lang === 'fi' ? 'https://www.minunmaatilani.fi/tutustu-pessl-saaasemaan' : 'https://www.minunmaatilani.fi/sv/bekanta-dig-med-pessl-vaderstationen/';
}

export const getRegistrationNumber = (pesticides, product) => {
    if (!pesticides.length) return "";
    var value = pesticides[1].options.find(v => v.value === product);
    if (!value) return "";
    if (value.registrationNumber === "9990" || value.registrationNumber === "9999") return "-";
    return value.registrationNumber;
}

export const processWeatherCardData = (data) => {
    var airTemperature = data.stationData.weatherData.find(d => d.measurementType === MeasurementType.AirTemperature);
    var precipitation = data.stationData.weatherData.find(d => d.measurementType === MeasurementType.Precipitation);
    var windSpeed = data.stationData.weatherData.find(d => d.measurementType === MeasurementType.WindSpeed);
    var relativeHumidity = data.stationData.weatherData.find(d => d.measurementType === MeasurementType.RelativeHumidity);
    var dewPoint = data.stationData.weatherData.find(d => d.measurementType === MeasurementType.DewPoint);

    var items = [
        {
            label: airTemperature ? airTemperature.name : '',
            type: MeasurementType.AirTemperature,
            value: airTemperature && airTemperature.value ? airTemperature.value.toFixed(1) : "-",
            // unit degree celsius in utf-8
            unit: airTemperature ? airTemperature.unit : '',

            secondLabel: precipitation ? precipitation.name : '',
            secondType: MeasurementType.Precipitation,
            secondValue: precipitation && precipitation.value ? precipitation.value.toFixed(1) : "-",
            secondUnit: precipitation ? precipitation.unit : ''
        },
        {
            label: windSpeed ? windSpeed.name : '',
            type: MeasurementType.WindSpeed,
            value: windSpeed && windSpeed.value ? windSpeed.value.toFixed(1) : "-",
            unit: windSpeed ? windSpeed.unit : '',

            secondLabel: "Tuulen suunta",
            secondType: MeasurementType.WindDirection,
            secondValue: '',
            secondUnit: '',
            direction: windSpeed ? windSpeed.windDirection : ''
        },
        {
            label: relativeHumidity ? relativeHumidity.name : '',
            type: MeasurementType.RelativeHumidity,
            value: relativeHumidity && relativeHumidity.value ? relativeHumidity.value.toFixed(1) : "-",
            unit: relativeHumidity ? relativeHumidity.unit : '',

            secondLabel: dewPoint ? dewPoint.name : '',
            secondType: MeasurementType.DewPoint,
            secondValue: dewPoint && dewPoint.value ? dewPoint.value.toFixed(1) : "-",
            secondUnit: dewPoint ? dewPoint.unit : ''
        },
    ];

    var deltaT = data.stationData.weatherData.find(d => d.measurementType === MeasurementType.DeltaT);
    var dailyET0 = data.stationData.weatherData.find(d => d.measurementType === MeasurementType.DailyET0);
    var windGust = data.stationData.weatherData.find(d => d.measurementType === MeasurementType.WindGust);
    var leafWetness = data.stationData.weatherData.find(d => d.measurementType === MeasurementType.LeafWetness);
    var VPD = data.stationData.weatherData.find(d => d.measurementType === MeasurementType.VPD);
    var solarRadiation = data.stationData.weatherData.find(d => d.measurementType === MeasurementType.SolarRadiation);
    var sunshineDuration = data.stationData.weatherData.find(d => d.measurementType === MeasurementType.SunshineDuration);
    var soilTemperature = data.stationData.weatherData.find(d => d.measurementType === MeasurementType.SoilTemperature);
    var soilMoisture = data.stationData.weatherData.find(d => d.measurementType === MeasurementType.SoilMoisture);

    var dataNotAvailable = false;
    if (!airTemperature?.value && !soilTemperature?.value && !windSpeed?.value && !relativeHumidity?.value) {
        dataNotAvailable = true;
    }

    // #region soil sensors
    const buildSoilSensors = (sensorTypes) => sensorTypes.map(measurementType => {
        var sensor = data.stationData.weatherData.find(d => d.measurementType === measurementType);
        return {
            label: sensor?.name ?? '',
            type: measurementType,
            value: sensor && sensor.value ? sensor.value.toFixed(1) : "-",
            unit: sensor?.unit ?? ''
        };
    });

    var soilExtraSensors = buildSoilSensors([
        MeasurementType.SoilMoistureSensor_1, MeasurementType.SoilMoistureSensor_2, MeasurementType.SoilMoistureSensor_3,
        MeasurementType.SoilMoistureSensor_4, MeasurementType.SoilMoistureSensor_5, MeasurementType.SoilMoistureSensor_6
    ]);

    var soilExtraSensors2 = buildSoilSensors([
        MeasurementType.SoilTemperatureSensor_1, MeasurementType.SoilTemperatureSensor_2, MeasurementType.SoilTemperatureSensor_3,
        MeasurementType.SoilTemperatureSensor_4, MeasurementType.SoilTemperatureSensor_5, MeasurementType.SoilTemperatureSensor_6
    ]);
    // #endregion

    var extraItems = [
        {
            label: deltaT ? deltaT.name : '',
            type: MeasurementType.DeltaT,
            value: deltaT && deltaT.value ? deltaT.value.toFixed(0) : "-",
            unit: deltaT ? deltaT.unit : ''
        },
        {
            label: dailyET0 ? dailyET0.name : '',
            type: MeasurementType.DailyET0,
            value: dailyET0 && dailyET0.value ? dailyET0.value.toFixed(1) : "-",
            unit: dailyET0 ? dailyET0.unit : ''
        },
        {
            label: windGust ? windGust.name : '',
            type: MeasurementType.WindGust,
            value: windGust && windGust.value ? windGust.value.toFixed(1) : "-",
            unit: windGust ? windGust.unit : ''
        },
        {
            label: leafWetness ? leafWetness.name : '',
            type: MeasurementType.LeafWetness,
            value: leafWetness && leafWetness.value ? leafWetness.value.toFixed(0) : "-",
            unit: leafWetness ? leafWetness.unit : '',

            secondLabel: VPD ? VPD.name : '',
            secondType: MeasurementType.VPD,
            secondValue: VPD && VPD.value ? VPD.value.toFixed(1) : "-",
            secondUnit: VPD ? VPD.unit : ''
        },
        {
            label: solarRadiation?.name ?? '',
            type: MeasurementType.SolarRadiation,
            value: solarRadiation && solarRadiation.value ? solarRadiation.value.toFixed(0) : "-",
            unit: solarRadiation?.unit ?? '',

            secondLabel: sunshineDuration?.name ?? '',
            secondType: MeasurementType.SunshineDuration,
            secondValue: sunshineDuration && sunshineDuration.value ? sunshineDuration.value.toFixed(0) : "-",
            secondUnit: sunshineDuration?.unit ?? ''
        }
    ];

    // Check if sensor data includes extra sensors for soil temperature and moisture (=> Metos 5.0 stations)
    var showExtraSensors = soilMoisture.value === null && soilTemperature.value === null &&
        [...soilExtraSensors, ...soilExtraSensors2].some(sensor => sensor.value !== "-");
    if (showExtraSensors) {
        extraItems = extraItems.concat(soilExtraSensors, soilExtraSensors2);
    }
    else {
        // This definition is for weather stations that do not have extra sensors (uMetos clima & nMetos)
        var basicSoilSensors = [{
            label: soilTemperature?.name ?? '',
            type: MeasurementType.SoilTemperature,
            value: soilTemperature && soilTemperature.value ? soilTemperature.value.toFixed(1) : "-",
            unit: soilTemperature?.unit ?? '',

            secondLabel: soilMoisture?.name ?? '',
            secondType: MeasurementType.SoilMoisture,
            secondValue: soilMoisture && soilMoisture.value ? soilMoisture.value.toFixed(1) : "-",
            secondUnit: soilMoisture?.unit ?? ''
        }];
        extraItems = extraItems.concat(basicSoilSensors);
    }

    return {
        items,
        extraItems,
        dataNotAvailable
    };
}